module.exports = __webpack_public_path__ + "static/media/panco.dc662aef.jpg";